// Welcome Messages
export const WELCOME_MESSAGES = {
    PERSONALIZED: (userName, bookingCount) =>
        `Hi ${userName},\n\nYou've booked ${bookingCount} time${bookingCount > 1 ? 's' : ''} with MillionSpaces! We're excited to have you back.\nWhat are you looking to book today?`,

    PERSONALIZED_WITH_PREVIOUS: (userName, bookingCount, previousEventType, previousLocation = 'Colombo') =>
        `Hi ${userName},\n\nYou've booked ${bookingCount} time${bookingCount > 1 ? 's' : ''} with MillionSpaces! We're excited to have you back.\n\nYour previous room was a ${previousEventType} in ${previousLocation}. Do you want to book the same space?`,

    DEFAULT: "Hi there,\n\nI am Spacey, your smart assistant ready to help you find the perfect space.",

    FALLBACK: "Hi there!\n\nWelcome to MillionSpaces, your trusted booking platform to discover meeting rooms, workspaces, virtual offices & photoshoot spaces across Sri Lanka.\n\nI'm Spacey, your smart assistant. Ready to help you find the perfect space!",

    SECONDARY: "Hi I'm Spacey, What are you looking for today?"
};

// Booking Process Messages
export const BOOKING_PROCESS_MESSAGES = {
    EXPLANATION: "There are a few ways to do that. First, you can select a workspace type from the categories above, manually browse to find the right workspace, and book it. Alternatively, you can use the chat option and follow the guided stepper to get a recommendation and book it. Or, you can contact our agent and ask them to book a space for you.",

    STEPS: "Tell first select his preferred workspace type, then choose the location and budget. Based on that, Spacey will suggest suitable spaces. Click on a suggested item to view the details, then click 'Continue' to select the space.",

    RESTRICTION: "Sorry, I cannot book a workspace for you. Please select an option, view the details, and click 'Continue' to book."
};

// Workspace Messages
export const WORKSPACE_MESSAGES = {
    OPTIONS_TITLE: "Choose a workspace type:",
    CURRENT_SELECTION: (workspaceType) => `\n\n✅ **Currently Selected:** ${workspaceType.label}`,
    NO_SELECTION: '\n\nℹ️ **No workspace type selected yet**',
    NO_OPTIONS: "Sorry, no workspace options are currently available. Please try again later.",
    LOADING_ERROR: "Sorry, I'm having trouble loading workspace options. Please try again later.",
    TYPE_RESTRICTION: (selectedWorkspaceType) => `Information is only available for the currently selected workspace type: ${selectedWorkspaceType.label}. To inquire about a different type, please select it from the above.`
};

// Location Messages
export const LOCATION_MESSAGES = {
    TITLE: "Choose a location:",
    SELECT_PLACEHOLDER: "Select a location...",
    NO_LOCATIONS_FOUND: (workspaceType) => `No locations found for the selected workspace type: ${workspaceType}`,
    NO_SPACES_FOUND: (location) => `No spaces found for the selected location: ${location}`
};

// Price Range Messages
export const PRICE_RANGE_MESSAGES = {
    TITLE: "Choose a price range:",
    NO_PRICE_RANGES: (location) => `No price ranges could be generated from the available spaces for ${location}`,
    NO_SPACES_IN_RANGE: (priceRange) => `No spaces found within the selected price range: ${priceRange}`,
    SPACES_FOUND: (count) => `I found ${count} spaces that match your criteria. Here are the available options:`
};

// Space Selection Messages
export const SPACE_SELECTION_MESSAGES = {
    RECOMMENDED_TITLE: "Recommended Spaces:",
    SPACE_OPENED: (spaceName) => `Perfect! I've opened the booking page for ${spaceName}. You can now select your preferred date and time.`,
    FOLLOW_UP_TITLE: "Would you like to contact our agent for assistance, or would you like to find something else?",
    SELECT_DATE: "What date do you need the space for?"
};

// Follow-up Messages
export const FOLLOW_UP_MESSAGES = {
    TITLE: "What would you like to do next?",
    CONTACT_AGENT: "Need help with this space?",
    FIND_SOMETHING_ELSE: "Not what you're looking for?",
    FIND_SOMETHING_ELSE_TITLE: "No spaces found within the selected price range. Would you like to try a different price range or find something else?"
};

// Contact Form Messages
export const CONTACT_FORM_MESSAGES = {
    TITLE: "Contact Our Agent",
    SUCCESS: "Thank you! Your message has been sent. We'll get back to you soon.",
    ERROR: "Sorry, there was an error sending your message. Please try again or contact us directly.",
    VALIDATION_ERROR: "Please check your form inputs and try again."
};

// Info Panel Messages
export const INFO_PANEL_MESSAGES = {
    TITLE: "About Spacey",
    DESCRIPTION: "Spacey is your AI-powered workspace assistant, designed to help you find and book the perfect workspace for your needs.",
    ABOUT_SPACEY: "About Spacey",
    CHAT_COMMANDS_TITLE: "Chat Commands:",
    CONTACT_AGENT_TITLE: "How to Contact a Human Agent:",
    HELP_WITH_TITLE: "What Spacey Can Help With:",
    IMPORTANT_NOTES_TITLE: "Important Notes:",
    GOT_IT: "Got it"
};

// Chat Commands
export const CHAT_COMMANDS = {
    HELP: {
        COMMAND: "help",
        ALTERNATIVE: "?",
        DESCRIPTION: "Show this information panel"
    },
    OPTIONS: {
        COMMAND: "options",
        DESCRIPTION: "Show all available workspace types"
    },
    AGENT: {
        COMMAND: "agent",
        ALTERNATIVE: "human",
        DESCRIPTION: "Contact a human agent"
    },
    ASK_SPACES: {
        DESCRIPTION: "Get detailed space recommendations"
    }
};

// Help Information
export const HELP_INFORMATION = {
    COMMANDS: [
        { command: '"help" or "?"', description: 'Show this information panel' },
        { command: '"options"', description: 'Show all available workspace types' },
        { command: '"agent" or "human"', description: 'Contact a human agent' },
        { command: 'Ask about spaces', description: 'Get detailed space recommendations' }
    ],
    CONTACT_AGENT: [
        'Type "agent" or "human" in the chat',
        'Click "Need help with this space" button when available',
        'Use the contact form for detailed assistance'
    ],
    CAN_HELP_WITH: [
        'Finding workspaces based on your preferences',
        'Comparing pricing and amenities',
        'Guiding you through the booking process',
        'Providing workspace recommendations',
        'Showing available workspace options (type "options")'
    ],
    IMPORTANT_NOTES: [
        'Always verify pricing and availability before booking',
        'Contact human agents for complex requests',
        'Check workspace policies and cancellation terms'
    ]
};

// Disclaimer Messages
export const DISCLAIMER_MESSAGES = {
    TEXT: "Spacey can make mistakes. Please check info.",
    TOOLTIP: "Click for more information"
};

// Login Messages
export const LOGIN_MESSAGES = {
    PROMPT: "Please log in to get personalized workspace recommendations",
    ICON: "🔐"
};

// Previous Booking Messages
export const PREVIOUS_BOOKING_MESSAGES = {
    QUESTION: "Do you want to book the same space?",
    YES: "Yes",
    NO: "No"
};

// Error and Fallback Messages
export const ERROR_FALLBACK_MESSAGES = {
    GENERAL: 'Sorry, I could not process your request. You can type "agent" to speak with a human agent.',
    NO_WORKSPACE_OPTIONS: "Sorry, no workspace options are currently available. Please try again later.",
    WORKSPACE_OPTIONS_LOADING_ERROR: "Sorry, I'm having trouble loading workspace options. Please try again later.",
    SEARCH_ERROR: "I'm having trouble searching for spaces right now. Please try again later.",
    PRICE_RANGE_ERROR: "I'm having trouble finding price ranges. Please try again later.",
    SPACES_ERROR: "I'm having trouble finding spaces. Please try again later."
};
